import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';

const renderType = ({ type, label: __label }) => {
    let symbol = '';
    let label = '';

    switch (type) {
        case 'first':
            symbol = __label || '«';
            label = 'First';
            break;
        case 'previous':
            symbol = __label || '‹';
            label = 'Previous';
            break;
        case 'last':
            symbol = __label || '»';
            label = 'Last';
            break;
        case 'next':
            symbol = __label || '›';
            label = 'Next';
            break;
        case 'dots':
            symbol = '…';
            label = 'dots';
            break;
        default:
            break;
    }
    return (
        <Fragment>
            <span aria-hidden="true">{symbol}</span>
            <span className="sr-only">{label}</span>
        </Fragment>
    );
};
const renderLink = ({ to, label, disabled }) => {
    return disabled ? (
        <span className="page-link">{label}</span>
    ) : (
            <Link to={to} className="page-link">
                {label}
            </Link>
        );
};

const PaginationItem = ({ to, active, disabled, label, type }) => {
    const itemClasses = cx('page-item', { active: active }, { disabled: disabled });

    const __label = type ? renderType({ type, label }) : label;

    return <li className={itemClasses}>{renderLink({ to, label: __label, disabled })}</li>;
};

PaginationItem.propTypes = {
    to: PropTypes.string,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    label: PropTypes.number,
    type: PropTypes.string,
};

export default PaginationItem;
